import * as React from "react";

export const AcceptAllIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <path d="M25.168 11.264c.322.322.349.827.08 1.18l-.08.092-7.584 7.584c-.322.322-.827.349-1.18.08l-.092-.08-1.048-1.048c-.352-.352-.352-.922 0-1.273.322-.322.827-.35 1.18-.08l.092.08.412.411 6.947-6.946c.351-.352.921-.352 1.273 0zm-5.798 0c.322.322.349.827.08 1.18l-.08.092-7.584 7.584c-.322.322-.827.349-1.18.08l-.092-.08-3.25-3.25c-.352-.352-.352-.922 0-1.273.322-.322.827-.35 1.18-.08l.092.08 2.614 2.613 6.947-6.946c.351-.352.921-.352 1.273 0z" />
    </svg>
);
